import React from 'react';
import PropTypes from 'prop-types';
import * as Feather from 'react-feather';
import { Button } from 'reactstrap';

const sizeMapper = {
  lg: 'circular-button-xl',
  sm: 'circular-button'
};

const CircularButton = (props) => {
  const {iconName, onClick, size, style, disabled} = props;
  const Icon = Feather[iconName];

  return(
    <Button 
      disabled={disabled}
      color={style} 
      className={sizeMapper[size]}
      onClick={onClick}>
      <Icon />
    </Button>
  );
};

CircularButton.defaultProps = {
  size: 'lg',
  disabled: false
};

CircularButton.propTypes = {
  style: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default CircularButton;